import { Component, inject } from '@angular/core'
import { Router, RouterModule } from '@angular/router'
import { Illustration, IllustrationComponent, PageComponent, TertiaryButtonComponent } from '@ftr/foundation'
import { featureFlag } from '@ftr/ui-feature-flags'

@Component({
  selector: 'ftr-not-found',
  templateUrl: './not-found.component.html',
  styleUrls: ['./not-found.component.css'],
  imports: [RouterModule, IllustrationComponent, PageComponent, TertiaryButtonComponent],
})
export class NotFoundComponent {
  readonly illustration = Illustration
  private readonly router = inject(Router)

  protected isPublicNavigationEnabled = featureFlag('public-navigation')

  goToHome(): void {
    this.router.navigate(['/'])
  }
}
